(function () {
  /**
   * @ngdoc module
   * @name akitabox.ui.components.reportingCharts.assigneeChart
   *
   * @param {Object} building - building to build the chart with
   */
  angular
    .module("akitabox.ui.components.reportingCharts.assigneeChart", [
      "akitabox.constants",
      "akitabox.core.services.chart",
      "akitabox.core.services.flag",
      "akitabox.ui.directives.stackChart",
    ])
    .component("abxAssigneeChart", {
      bindings: {
        buildings: "<abxBuildings",
        startDate: "<abxStartDate",
        endDate: "<abxEndDate",
        filters: "<abxFilters",
      },
      controller: AbxAssigneeController,
      controllerAs: "vm",
      templateUrl:
        "app/core/ui/components/reporting-charts/assignee-chart/assignee-chart.component.html",
    });
  function AbxAssigneeController(
    // Angular
    $log,
    $timeout,
    // Constants
    models,
    MINIMUM_RENDER_DELAY,
    // Services
    ChartService,
    ShadowService
  ) {
    var self = this;
    var config = {};

    var GA_CATEGORY = "reporting";

    // Attributes
    self.idTag = "assignee-chart";
    self.data = [];
    self.groupKey = "_id";
    self.loading = true;
    self.showChart = false;
    self.nullValue = "Unassigned";
    self.hoverLabel = models.WORK_ORDER.PLURAL;

    self.yAxisOptions = [
      "# Completed",
      "# Open",
      "# Overdue",
      "# Scheduled",
      "Avg. Duration (Days)",
    ];

    self.activeYAxisOption = self.yAxisOptions[0];
    self.stackOptions = [];
    self.selectedStack = "---";
    self.excludeStackOptions = ["Assignee", "Work Performed By", "Time Code"];
    self.hoverLabel = "";

    self.onYAxisChange = onYAxisChange;
    self.onStackChange = onStackChange;
    self.onStackHover = onStackHover;

    // ------------------------
    //   Life Cycle
    // ------------------------

    self.$onInit = function () {
      if (!self.buildings || self.buildings.length === 0) {
        $log.error("abxAssignee: abx-buildings is required");
        return;
      }
    };

    self.$onChanges = function (changes) {
      if (changes.buildings) {
        config = ChartService.getChartConfig(
          self.buildings,
          models.WORK_ORDER.MODEL
        );
        self.stackOptions = ChartService.getStackOptions(
          models.WORK_ORDER.MODEL,
          self.buildings.length > 1,
          ["Age"],
          self.excludeStackOptions
        );
      }
      if (changes.startDate || changes.endDate) {
        self.yAxisFilterOptions = ChartService.getYAxisConfig(
          self.yAxisOptions,
          self.startDate,
          self.endDate
        );
        self.yAxisConfig = self.yAxisFilterOptions[self.activeYAxisOption];
        self.hoverLabel = self.yAxisConfig.label;
      }
      if (changes.filters) {
        updateFilters(self.yAxisConfig.lookupModel);
      }
      if (
        changes.startDate ||
        changes.endDate ||
        changes.filters ||
        changes.buildings
      ) {
        calculateStats();
      }
    };

    // ------------------------
    //   Events
    // ------------------------

    // ------------------------
    //   Public Functions
    // ------------------------

    function onStackHover($event) {
      self.highlightedStack = $event.value;
    }

    function onStackChange($event) {
      ShadowService.setSelectedOption($event.value);
      ShadowService.sendEvent(GA_CATEGORY, "switch-stack-by", self.idTag);
      self.selectedStack = $event.model;
      updateFilters(self.yAxisConfig.lookupModel);
      calculateStats();
    }

    function onYAxisChange($event) {
      ShadowService.setSelectedOption($event.value);
      ShadowService.sendEvent(GA_CATEGORY, "switch-y-axis", self.idTag);
      self.activeYAxisOption = $event.model;
      self.yAxisConfig = self.yAxisFilterOptions[self.activeYAxisOption];
      self.hoverLabel = self.yAxisConfig.label;
      updateFilters(self.yAxisConfig.lookupModel);
      calculateStats();
    }

    // ------------------------
    //   Private Functions
    // ------------------------

    function setShowChart() {
      var options = {
        startDate: self.startDate,
        endDate: self.endDate,
        yAxis: self.activeYAxisOption,
      };
      self.showChart = ChartService.shouldShowChart(
        models.WORK_ORDER.MODEL,
        ChartService.CHART_TYPE_BAR,
        self.data,
        options
      );
    }

    /**
     * Calculate the workOrder stats for the given date
     */
    function calculateStats() {
      if (
        self.startDate.toString() === "Invalid Date" ||
        self.endDate.toString() === "Invalid Date"
      )
        return;
      self.loading = true;
      self.showChart = false;
      var params;
      // model to append in the lookup stage
      var lookupModel;
      // model to use for the stats function
      var modelName;
      if (self.yAxisConfig && self.yAxisConfig.lookupModel) {
        lookupModel = self.yAxisConfig.lookupModel;
        modelName = self.yAxisConfig.overrideModel;

        params = {
          group_field: "identity._id",
          lookup_field: lookupModel,
          unwind_field: "assignees",
          unwind_lookup: true,
        };

        // reset config to use the overrideModel
        modelName = self.yAxisConfig.overrideModel;
      } else {
        params = {
          group_field: "identity._id",
          unwind_field: "assignees",
          unwind_lookup: true,
        };

        // reset config to use the original model
        modelName = models.WORK_ORDER.MODEL;
      }
      config = ChartService.getChartConfig(self.buildings, modelName);

      params = angular.extend(params, self.filters, self.yAxisConfig.params);

      if (config.buildingInString) params.buildings = config.buildingInString;

      config
        .statsFunction(config.parentId, params)
        .then(function (results) {
          return ChartService.updateIdentityDisplayNames(
            results,
            self.buildings
          );
        })
        .then(function (results) {
          var data = results;

          self.legendValues = [];

          ChartService.addEmptyBars(data, self.filters.assignee_email);
          if (!params.stack_field) {
            self.data = self.yAxisConfig.transform(data);
            return;
          }

          if (params.stack_field === "intent") {
            self.stackSort = ChartService.sortIntent;
          } else if (params.stack_field === "age_group") {
            self.stackSort = ChartService.sortAge;
          } else {
            self.stackSort = undefined; // sort function must either be undefined or function
          }

          return ChartService.parseStackData(
            data,
            params.stack_field,
            params.stack_field === "building" ? config.buildingMap : null,
            self.yAxisConfig.transform,
            self.buildings
          );
        })
        .then(function (stackData) {
          if (!stackData) {
            // no stack_field provided, self.data is already set above
            return;
          }
          self.legendValues = stackData.keys.sort(self.stackSort);
          self.data = stackData.data;
        })
        .then(function () {
          return $timeout(angular.noop, MINIMUM_RENDER_DELAY);
        })
        .finally(function () {
          self.loading = false;
          setShowChart();
        });
    }

    /**
     *
     * @param {String} lookupModel model to prepend to the name of the stack filter
     */

    function updateFilters(lookupModel) {
      self.filters = ChartService.updateStackFilter(
        self.selectedStack,
        self.filters,
        lookupModel
      );
    }
  }
})();
